// store/modules/cart.js

const state = () => ({
    items: JSON.parse(localStorage.getItem('cart') || '[]')
});

const mutations = {
    setCart(state, items) {
        state.items = items;
        localStorage.setItem('cart', JSON.stringify(items));
    },
    addItem(state, item) {
        const existing = state.items.find(i => i.id === item.id);
        const qty = parseInt(item.quantity) || 1;

        if (existing) {
            existing.quantity += qty;
        } else {
            state.items.push({ ...item, quantity: qty });
        }

        localStorage.setItem('cart', JSON.stringify(state.items));
    },
    updateQuantity(state, { id, delta }) {
        const item = state.items.find(i => i.id === id);
        if (item) {
            item.quantity = Math.max(1, item.quantity + delta);
            localStorage.setItem('cart', JSON.stringify(state.items));
        }
    },
    removeItem(state, id) {
        state.items = state.items.filter(i => i.id !== id);
        localStorage.setItem('cart', JSON.stringify(state.items));
    },
    clearCart(state) {
        state.items = [];
        localStorage.removeItem('cart');
    },
};

const actions = {
    loadCart({ commit }) {
        const items = JSON.parse(localStorage.getItem('cart') || '[]');
        commit('setCart', items);
    },
    clearCart({ commit }) {
        commit('clearCart');
    }
};

const getters = {
    clearCart({ commit }) {
        commit('clearCart');
    },
    cartTotal: state => {
        return state.items.reduce((sum, item) => {
            const qty = parseFloat(item.quantity) || 0;
            const price = parseFloat(item.referencePrice) || 0;
            return sum + (qty * price);
        }, 0).toFixed(2);
    },
    cartItems: state => state.items,
    isCartEmpty: state => state.items.length === 0,
    cartTotalItems: state => state.items.length
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
